export const formatCategoryAttributeFilterQueryString = (values?: Record<string, string[]>) =>
  values
    ? Object.keys(values).reduce((prev: string[], curr) => [...prev, ...values[curr]], [])
    : [];
